import styled from 'styled-components';

const ServicesPageContainer = styled.div`
    padding-top: var(--section-padding);
    padding-bottom: var(--section-padding);

    .services-container {
        @media (min-width: 768px) {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
            grid-column-gap: 40px;
            grid-row-gap: 60px;
        }
    }
`;

export default ServicesPageContainer;
